import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class UploadService {

  constructor(private authHttp: AuthHttp) { }


  uploadFileToFrontPage(file: any) {
    // console.log("upload file")
    // console.log(memberId)
    // console.log("FormData");
    // console.log(formData);
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post(`/api/upload/frontpage/upload/`, formData).map(res => res.json());
  }

  uploadFileToTutorials(file: any) {
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post(`/api/upload/tutorials/upload/`, formData).map(res => res.json());
  }

  deleteFileFromFrontPage(filename: string){
    return this.authHttp.get('/api/upload/frontpage/delete/'+filename).map(res => res.json)
  }

  deleteFileFromTutorials(filename: string){
    return this.authHttp.get('/api/upload/tutorials/delete/'+filename).map(res => res.json)
  }

  uploadFileToDocument(file: any){
    var formData = new FormData();
    formData.append("file",file);
    return this.authHttp.post('/api/upload/document',formData).map(res => res.json());
  }

  uploadCourseFile(file: any){
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post('/api/upload/courseFile', formData).map(res => res.json());
  }

  uploadClothesPicture(file: any){
    var formData = new FormData();
    formData.append("file",file);
    return this.authHttp.post('/api/upload/clothes/upload', formData).map( res => res.json());
  }

  uploadSignature(file: any){
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post('/api/upload/signature/upload', formData).map((res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    });
  }

  uploadStamp(file: any){
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post('/api/upload/stamp/upload', formData).map((res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    });
  }

  uploadNonMemberActivityPoster(file: any){
    var formData = new FormData();
    formData.append("file", file);
    return this.authHttp.post('/api/upload/nonmemberSubscription/upload', formData).map((res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    });
  }



  checkAsset(asset: string){
    return this.authHttp.get('api/check/'+asset).map((res:any)=>{
      let value = "";
      if (res.status == 200){
        value=res.json();
      }
      return { 'status': res.status, 'value': value }
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/upload.service.ts